import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 512 512" {...props}><path fill="#ff5e34" d="M256 512a256 256 0 100-512 256 256 0 100 512zm-64-352h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z" /></svg>);